var map = {
	"./Accountancy.jpg": [
		25239,
		5239
	],
	"./Banking and insurance.jpg": [
		95275,
		5275
	],
	"./Chemical-industry.jpg": [
		69927,
		9927
	],
	"./Cohesive Estonia.jpg": [
		55446,
		2400
	],
	"./Commerce.jpg": [
		99000,
		9000
	],
	"./Construction and real estate.jpg": [
		49954,
		9954
	],
	"./Electronics_industry.jpg": [
		81609,
		1609
	],
	"./Engineering-industry.jpg": [
		35446,
		5446
	],
	"./Equal treatment.jpg": [
		5046,
		5046
	],
	"./Food industry.jpg": [
		86815,
		6815
	],
	"./Forestry and timber industry.jpg": [
		28210,
		8210
	],
	"./HARJU_county.jpg": [
		15608,
		5608
	],
	"./HIIU_county.jpg": [
		27667,
		7667
	],
	"./IDA_county.jpg": [
		61853,
		1853
	],
	"./Information and communication technology .jpg": [
		83747,
		3747
	],
	"./JARVA_county.jpg": [
		42550,
		2550
	],
	"./JOGEVA_county.jpg": [
		70486,
		486
	],
	"./LAANE_VIRU.jpg": [
		32097,
		2097
	],
	"./LAANE_county.jpg": [
		26361,
		6361
	],
	"./Main indicators.jpg": [
		34651,
		4651
	],
	"./Marine industry.jpg": [
		92571,
		2571
	],
	"./Ministry of Defence.jpg": [
		26122,
		6122
	],
	"./Ministry of Economic Affairs and Communications.jpg": [
		37274,
		7274
	],
	"./Ministry of Finance.jpg": [
		72885,
		2885
	],
	"./Ministry of Foreign Affairs.jpg": [
		52621,
		2621
	],
	"./Ministry of Justice.jpg": [
		38291,
		8291
	],
	"./Ministry of Rural Affairs.jpg": [
		46519,
		6519
	],
	"./Ministry of Social Affairs.jpg": [
		27750,
		7750
	],
	"./Ministry of the Environment.jpg": [
		99271,
		9271
	],
	"./Ministry of the Interior.jpg": [
		50226,
		226
	],
	"./PARNU_county.jpg": [
		32980,
		2980
	],
	"./POLVA_county.jpg": [
		64937,
		4937
	],
	"./Postal and courier activities.jpg": [
		88104,
		8104
	],
	"./Printing-and-paper-industry.jpg": [
		63449,
		3449
	],
	"./RAPLA_county.jpg": [
		75111,
		5111
	],
	"./SAARE_county.jpg": [
		37872,
		7872
	],
	"./Statistics on Tallinn.jpg": [
		88437,
		8437
	],
	"./Sustainable development.jpg": [
		89758,
		9758
	],
	"./TARTU_county.jpg": [
		45702,
		5702
	],
	"./Tourism industry.jpg": [
		13588,
		3588
	],
	"./VALGA_county.jpg": [
		23488,
		3488
	],
	"./VILJANDI_county.jpg": [
		68,
		68
	],
	"./VORU_county.jpg": [
		8355,
		8355
	],
	"./Whole.jpg": [
		92682,
		2682
	],
	"./Youth monitoring.jpg": [
		99280,
		9280
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 81553;
module.exports = webpackAsyncContext;